var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.entity.LastModifiedBy)?_c('small',{staticClass:"last-modified-by"},[_vm._v(" Last modified by "+_vm._s(_vm.entity.LastModifiedBy.TransactUser.UserGivenName)+" on "+_vm._s(_vm._f("date")(_vm.entity.LastModifiedBy.TransactUtc))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }